import { ReactNode } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { cn } from "@/lib/utils";

/**
 * Shared section heading for SoundCheck rails/sections.
 * Keeps eyebrow + title typography consistent across Home and shared rails.
 * Editorial (Fraunces) styling stays reserved for page-level heroes.
 */
interface SectionHeadingProps {
  eyebrow?: ReactNode;
  title: string;
  id?: string;
  to?: string;
  ctaLabel?: string;
  className?: string;
}

export const SectionHeading = ({
  eyebrow,
  title,
  id,
  to,
  ctaLabel = "View all",
  className,
}: SectionHeadingProps) => (
  <div className={cn("flex items-end justify-between gap-3 mb-4", className)}>
    <div>
      {eyebrow && (
        <p className="text-[11px] tracking-[0.18em] uppercase text-muted-foreground font-medium mb-1 inline-flex items-center gap-1.5">
          {eyebrow}
        </p>
      )}
      <h2
        id={id}
        className="text-2xl md:text-3xl font-bold font-display tracking-tight"
      >
        {title}
      </h2>
    </div>
    {to && (
      <Link
        to={to}
        className="text-sm font-medium text-foreground/70 hover:text-foreground flex items-center gap-1 whitespace-nowrap shrink-0 transition-colors"
      >
        {ctaLabel}
        <ArrowRight className="h-4 w-4" />
      </Link>
    )}
  </div>
);

export default SectionHeading;
